import { Injectable, Optional } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthModuleConfig } from 'angular-oauth2-oidc';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authStorage: OAuthStorage,
    @Optional() private moduleConfig: OAuthModuleConfig
  ) { }

  private checkUrl(url: string): boolean {
    const found = this.moduleConfig.resourceServer.allowedUrls.find(u => url.startsWith(u));
    return !!found;
  }

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url.toLowerCase();

    if (!this.moduleConfig) {
      return next.handle(req);
    }
    if (!this.moduleConfig.resourceServer) {
      return next.handle(req);
    }
    if (!this.moduleConfig.resourceServer.allowedUrls) {
      return next.handle(req);
    }
    if (url.includes('zendesk')) {
      if (!this.checkUrl(url)) {
        return next.handle(req);
      }
    }

    const token = this.authStorage.getItem('id_token');
    if (token && !(url.includes('zendesk'))) {
      const header = 'Bearer ' + token;
      const headers = req.headers.set('x-auth', header);
      req = req.clone({ headers });
    }

    const token2 = this.authStorage.getItem('authorization_imp_token');
    if (token2) {
      const headers = req.headers.set('AuthorizationImp', token2);
      req = req.clone({ headers });
    }

    const country = this.authStorage.getItem('country');
    if (country && !(url.includes('zendesk'))) {
      const headers = req.headers.set('X-Country-Code', country);
      req = req.clone({ headers });
    }

    return next.handle(req);
  }
}
